import { render } from "./InvitationFormModal.vue?vue&type=template&id=4b48cb69"
import script from "./InvitationFormModal.vue?vue&type=script&lang=js"
export * from "./InvitationFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__